const EARTH_RADIUS_METERS = 6378137;
const STATE_CODE_TO_UF = Object.freeze({
  11: 'RO', 12: 'AC', 13: 'AM', 14: 'RR', 15: 'PA', 16: 'AP', 17: 'TO',
  21: 'MA', 22: 'PI', 23: 'CE', 24: 'RN', 25: 'PB', 26: 'PE', 27: 'AL', 28: 'SE', 29: 'BA',
  31: 'MG', 32: 'ES', 33: 'RJ', 35: 'SP',
  41: 'PR', 42: 'SC', 43: 'RS', 50: 'MS', 51: 'MT', 52: 'GO', 53: 'DF',
});

export function normalizarTexto(value) {
  return String(value ?? '').trim();
}

export function normalizarUf(value) {
  const normalized = normalizarTexto(value).toUpperCase();
  if (/^[A-Z]{2}$/.test(normalized)) return normalized;
  return STATE_CODE_TO_UF[Number(normalized)] || '';
}

function normalizeRing(input) {
  if (Array.isArray(input)) {
    return input
      .map(point => Array.isArray(point)
        ? [Number(point[0]), Number(point[1])]
        : [Number(point?.lng), Number(point?.lat)])
      .filter(([lng, lat]) => Number.isFinite(lng) && Number.isFinite(lat));
  }

  return input?.geometry?.coordinates?.[0]
    ?.map(([lng, lat]) => [Number(lng), Number(lat)])
    .filter(([lng, lat]) => Number.isFinite(lng) && Number.isFinite(lat)) || [];
}

export function calcularAreaHectares(input) {
  const ring = normalizeRing(input);
  if (ring.length < 3) return null;

  const closedRing = ring.length > 3
    && ring[0][0] === ring[ring.length - 1][0]
    && ring[0][1] === ring[ring.length - 1][1]
    ? ring
    : [...ring, ring[0]];

  let sphericalArea = 0;
  for (let index = 0; index < closedRing.length - 1; index += 1) {
    const [lngA, latA] = closedRing[index];
    const [lngB, latB] = closedRing[index + 1];
    const deltaLongitude = ((lngB - lngA) * Math.PI) / 180;
    sphericalArea += deltaLongitude
      * (2 + Math.sin((latA * Math.PI) / 180) + Math.sin((latB * Math.PI) / 180));
  }

  const hectares = Math.abs((sphericalArea * EARTH_RADIUS_METERS * EARTH_RADIUS_METERS) / 2) / 10000;
  return Number.isFinite(hectares) ? Number(hectares.toFixed(2)) : null;
}

export function calcularCentroGeometria(input) {
  const ring = normalizeRing(input);
  if (!ring.length) return null;

  const points = ring.length > 1
    && ring[0][0] === ring[ring.length - 1][0]
    && ring[0][1] === ring[ring.length - 1][1]
    ? ring.slice(0, -1)
    : ring;

  if (!points.length) return null;

  const totals = points.reduce((accumulator, [lng, lat]) => ({
    lng: accumulator.lng + lng,
    lat: accumulator.lat + lat,
  }), { lng: 0, lat: 0 });

  return {
    lat: Number((totals.lat / points.length).toFixed(7)),
    lng: Number((totals.lng / points.length).toFixed(7)),
  };
}

export function formatarAreaHectares(value) {
  if (value === null || value === undefined || value === '') return 'Área ainda não calculada';
  const area = Number(value);
  if (!Number.isFinite(area) || area <= 0) return 'Área ainda não calculada';
  return `${area.toLocaleString('pt-BR', {
    minimumFractionDigits: area < 10 ? 2 : 1,
    maximumFractionDigits: 2,
  })} ha`;
}
